const TimelineElement = [
    {
        id:1,
        title: "Xpert 360 Solutions",
        date: "Feb 24 - April 24",
        description: "Worked as A Frontend Developer to build responsive and interactive UI",
        teckstack: ["React.js", "Next.js", "MaterialUI", "GSAP"]
    },
    {
        id:2,
        title: "SayabiDevs",
        date: "July 24 - Sept 24",
        description: "Worked as Fullstack trainee, builds API's and Databases schemas",
        teckstack: ["C#", ".Net", "Authentication"]
    },
    {
        id:3,
        title: "Foxit Private Ltd",
        date: "Nov 24 - Present",
        description: "Working as a Dotnet trainee",
        teckstack: [".Net", "C#"]
    }
]
export default TimelineElement.reverse();